import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ReservationsPage from "@/pages/ReservationsPage";
import MenuPage from "@/pages/MenuPage";
import EventsPage from "@/pages/EventsPage";
import LocationPage from "@/pages/LocationPage";

const toastOptions = {
  style: {
    background: '#0b1412',
    color: '#E8E6D9',
    border: '1px solid rgba(212, 175, 55, 0.3)',
  },
};

function App() {
  return (
    <div className="App min-h-screen bg-[#050a09]">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reservations" element={<ReservationsPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/location" element={<LocationPage />} />
        </Routes>
        <Footer />
        <Toaster 
          position="top-right"
          toastOptions={toastOptions}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
